import React from "react";
import LegalPage from "@/components/legal/LegalPage";
import { privacyContent } from "@/content/legal/privacy";

export default function Privacy() {
  return (
    <LegalPage
      titleKey="public.privacy.title"
      updatedKey="public.lastUpdated"
      metaDescriptionKey="public.privacy.meta"
      sectionsByLang={privacyContent}
      testId="page-privacy"
    />
  );
}
